import React from 'react';
import { useSelector } from 'react-redux';
import * as Styles from './styles';
import { AppStore } from '../../store/applicationState';
import { InputChat } from './components/InputChat';
import { ListMessage } from './components/ListMessage';
import { usePrivateChat } from './hooks/usePrivateChat';
import { DEF_MARGIN } from '../../utils/consts';
import { TitleBlock } from '../TitleBlock';
import { EIcons } from '../../utils/globatTypes';
import { removeMiddleName } from '../../utils/removeMiddleName';

interface PrivateChatProps {}

export const PrivateChat: React.FC<PrivateChatProps> = () => {
  const { messages, usersInfo, sendMessage, selectPrivateChat, closePrivateChat } = usePrivateChat();

  const { PrivateChat, Sockets, Users } = useSelector((store: AppStore) => store);

  if (usersInfo && usersInfo.length > 0)
    return (
      <>
        <div style={{ marginBottom: DEF_MARGIN }}>
          <TitleBlock icon={EIcons.chat} title="Приватний чат" />
        </div>
        <Styles.Tabs>
          {usersInfo.map((user, i) => {
            if (i === 5) return null;
            return (
              <Styles.Tab key={`${user.id2}${i}`} active={PrivateChat.currentUserId2 === user.id2} last={i === usersInfo.length - 1}>
                <Styles.NameS onClick={() => selectPrivateChat(user)}>{removeMiddleName(user.fio)}</Styles.NameS>
                <button style={{ fontSize: '22px' }} onClick={() => closePrivateChat(user)}>
                  <i className="ion-ios-close-empty" />
                </button>
              </Styles.Tab>
            );
          })}
        </Styles.Tabs>
        <ListMessage user={Users.user} messages={messages} />
        <InputChat loading={PrivateChat.loading} isEnable={Sockets.room?.type_id !== 3} sendMessage={sendMessage} />
      </>
    );

  return (
    <>
      <div style={{ marginBottom: DEF_MARGIN }}>
        <TitleBlock icon={EIcons.chat} title="Приватний чат" />
      </div>
      <div style={{ textAlign: 'center', padding: '10px' }}>Немає чатів</div>
    </>
  );
};
